var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('console-content', {
    attrs: {
      "max-width": "1024"
    }
  }, [_c('v-row', {
    staticClass: "mt-4 px-1",
    attrs: {
      "align": "center"
    }
  }, [_c('v-col', {
    staticClass: "tit tit--lg",
    attrs: {
      "cols": "auto"
    }
  }, [_vm.board._id ? _c('span', [_vm._v("게시글 상세")]) : _c('span', [_vm._v("게시글 등록")])]), _c('v-spacer')], 1), _c('v-row', {
    staticClass: "mt-2"
  }, [_c('v-col', {
    staticClass: "pr-md-1",
    attrs: {
      "cols": "12",
      "md": "8"
    }
  }, [_c('v-card', {
    staticClass: "mx-1"
  }, [_c('v-card-title', {
    staticClass: "tit tit--xs font-weight-bold"
  }, [_vm._v("기본정보")]), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "제목",
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.board.subject,
      callback: function callback($$v) {
        _vm.$set(_vm.board, "subject", $$v);
      },
      expression: "board.subject"
    }
  }), _c('div', {
    staticClass: "mt-6"
  }, [_c('v-date-field', {
    attrs: {
      "label": "이벤트 시작일",
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.board.display.startDate,
      callback: function callback($$v) {
        _vm.$set(_vm.board.display, "startDate", $$v);
      },
      expression: "board.display.startDate"
    }
  })], 1), _c('div', {
    staticClass: "mt-6"
  }, [_c('v-date-field', {
    attrs: {
      "label": "이벤트 마감일",
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.board.display.endDate,
      callback: function callback($$v) {
        _vm.$set(_vm.board.display, "endDate", $$v);
      },
      expression: "board.display.endDate"
    }
  })], 1), _c('div', {
    staticClass: "mt-6"
  }, [_c('v-select', {
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "items": _vm.statusItems,
      "item-text": "text",
      "item-value": "value",
      "label": "상태",
      "persistent-placeholder": "",
      "hide-details": ""
    },
    model: {
      value: _vm.board.status,
      callback: function callback($$v) {
        _vm.$set(_vm.board, "status", $$v);
      },
      expression: "board.status"
    }
  })], 1)], 1)], 1)], 1), _c('v-col', {
    staticClass: " pl-md-1",
    attrs: {
      "cols": "12",
      "md": "4"
    }
  }, [_c('v-card', {
    staticClass: "mx-1 mt-3 mt-md-0"
  }, [_c('v-card-title', [_c('span', {
    staticClass: "tit tit--xs"
  }, [_vm._v("상단고정")]), _c('v-spacer'), _c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "hide-details": ""
    },
    model: {
      value: _vm.board.isNotice,
      callback: function callback($$v) {
        _vm.$set(_vm.board, "isNotice", $$v);
      },
      expression: "board.isNotice"
    }
  })], 1)], 1), _c('v-card', {
    staticClass: "mx-1 mt-3 mt-md-1"
  }, [_c('v-card-title', [_c('span', {
    staticClass: "tit tit--xs"
  }, [_vm._v("댓글여부")]), _c('v-spacer'), _c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "hide-details": ""
    },
    model: {
      value: _vm.board.isComment,
      callback: function callback($$v) {
        _vm.$set(_vm.board, "isComment", $$v);
      },
      expression: "board.isComment"
    }
  })], 1)], 1)], 1)], 1), _c('v-row', {
    staticClass: "mt-4"
  }, [_c('v-col', {
    staticClass: "pr-md-1"
  }, [_c('v-card', {
    staticClass: "mx-1"
  }, [_c('v-card-title', {
    staticClass: "tit tit--xs font-weight-bold"
  }, [_vm._v("썸네일")]), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "no-gutters": "",
      "align-center": ""
    }
  }, [_vm.thumb ? _c('v-img', {
    attrs: {
      "src": _vm.thumb,
      "max-width": "96",
      "height": "auto",
      "contain": ""
    }
  }) : _c('v-sheet', {
    attrs: {
      "width": "96",
      "height": "96",
      "color": "d-flex justify-center align-center grey lighten-2"
    }
  }, [_c('v-icon', [_vm._v("mdi-image")])], 1), _c('v-file-input', {
    attrs: {
      "disabled": !_vm.$hasScope(['root', 'admin'])
    },
    model: {
      value: _vm.board.thumb,
      callback: function callback($$v) {
        _vm.$set(_vm.board, "thumb", $$v);
      },
      expression: "board.thumb"
    }
  })], 1)], 1)], 1)], 1)], 1), _c('v-row', {
    staticClass: "mt-2"
  }, [_c('v-col', {
    staticClass: "pr-md-1",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-card', {
    staticClass: "mx-1"
  }, [_c('v-card-title', {
    staticClass: "tit tit--xs font-weight-bold"
  }, [_vm._v("이벤트 URL")]), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "URL",
      "disabled": !_vm.$hasScope(['root', 'admin']),
      "persistent-placeholder": "",
      "placeholder": "이벤트 url을 입력하면 해다 url로 이동합니다.",
      "hide-details": ""
    },
    model: {
      value: _vm.board.url,
      callback: function callback($$v) {
        _vm.$set(_vm.board, "url", $$v);
      },
      expression: "board.url"
    }
  })], 1)], 1)], 1)], 1), _c('v-card', {
    staticClass: "mt-4 mx-1"
  }, [_c('v-card-title', {
    staticClass: "tit tit--xs font-weight-bold"
  }, [_vm._v("상세정보")]), _c('v-card-text', [_c('naver-smarteditor', {
    model: {
      value: _vm.board.content,
      callback: function callback($$v) {
        _vm.$set(_vm.board, "content", $$v);
      },
      expression: "board.content"
    }
  })], 1)], 1), _c('v-row', {
    staticClass: "my-4"
  }, [_c('v-spacer'), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "disabled": !_vm.$hasScope(['root', 'admin'])
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("저장")])], 1), _c('v-spacer')], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }